/* eslint-disable react/jsx-no-useless-fragment */
import React, { FC, ReactNode } from 'react';

// source: https://javascript.plainenglish.io/how-to-combine-context-providers-for-cleaner-react-code-9ed24f20225e
export const combineComponents = (
	// eslint-disable-next-line @typescript-eslint/no-explicit-any
	...components: { Component: FC<any>; value?: object }[]
): FC<{ children: ReactNode }> => {
	return components.reduce(
		(AccumulatedComponents, { Component, value }) => {
			return ({ children }: { children: ReactNode }): JSX.Element => {
				return (
					<AccumulatedComponents>
						<Component {...value}>{children}</Component>
					</AccumulatedComponents>
				);
			};
		},
		({ children }: { children: ReactNode }) => <>{children}</>
	);
};
